import FormControlLabel from "@mui/material/FormControlLabel";
import Switch, { SwitchProps } from "@mui/material/Switch";
import Box from "@mui/material/Box";
import React from "react";
import { UseFormRegister } from 'react-hook-form'


interface FdSwitchProps extends SwitchProps {
    label?:React.ReactNode | string;
    placement?:any;
    register?: UseFormRegister<any>
    name: string
}

const FdSwitch = ({label, placement, disabled, name, sx={}, register, ...rest}: FdSwitchProps) => {
  return (
    <Box sx={{'& > .MuiFormControlLabel-root':{m:0},
    '& > .MuiFormControlLabel-labelPlacementStart .MuiSwitch-root':{marginLeft:'10px'},
    '& > .MuiFormControlLabel-labelPlacementEnd .MuiSwitch-root':{marginRight:'10px'},
    '& > .MuiFormControlLabel-labelPlacementTop .MuiSwitch-root':{marginTop:'10px'},
    '& > .MuiFormControlLabel-labelPlacementBottom .MuiSwitch-root':{marginBottom:'10px'},
    ...sx}}   className="switchComponent">
      <FormControlLabel control={<Switch disabled={disabled} {...rest} {...register && {...register(name)}} />} label={label} labelPlacement={placement} />
      </Box>
  );
};

export default FdSwitch;
